import React from 'react';

export default function RoleGate({ allow = [], children, fallback = null }) {
  try {
    const raw = localStorage.getItem('user');
    const user = raw ? JSON.parse(raw) : null;
    const role = user?.role || '';
    if (allow.length === 0 || allow.includes(role)) return children;
    return fallback || null;
  } catch {
    return fallback || null;
  }
}

